import { computed, makeObservable } from 'mobx';
import {auth} from 'main/tools';
import CalendarEvent from './CalendarEvent';

class TimeOffRequestEvent extends CalendarEvent {
  constructor(other) {
    super();

    makeObservable(this, {
      backgroundColor: computed,
      textColor: computed,
      borderColor: computed,
      canViewDetails: computed
    });
    this.merge(other);
  }

  get backgroundColor() {
    return this.extendedProps.status === 'approved' ? '#1776F5' : '#FFFFFF';
  }

  get textColor() {
    return this.extendedProps.status === 'approved' ? '#FFFFFF' : '#1776F5';
  }

  get borderColor() {
    return '#1776F5';
  }

  get canViewDetails() {
    return auth.hasAccess('::MANAGE_TIME_OFF');
  }
}

export default TimeOffRequestEvent;
